import React from 'react';
import { Spinner } from 'react-bootstrap';

const PageLoader = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </div>
);

export default PageLoader;
